/**
 * Rotas do domínio CREFabrica (R5, T104, DOM-17).
 *
 * Extraídas de `src/router/rotas/Fabricacao.ts`, onde viviam misturadas com as
 * rotas do domínio Fabricacao (AP-4). `obra` espalha dentro de
 * `/fabricacao/:obra` (LayoutFabricacao); `geral` espalha na raiz
 * (LayoutGeral) — mesmo formato de `views/CREObras`'s `creObrasRotas.ts`
 * (par `geral`/`obra`).
 *
 * `ListarDashboardGeralObra.vue` continua em `src/views/CREObras/`: é
 * genuinamente compartilhado entre os dois domínios (o próprio componente
 * decide o que buscar pelo `route.name`). **Atualizado na T102:** CREObras
 * migrou e ganhou barrel — o import passou de caminho profundo
 * (`@/views/CREObras/ListarDashboardGeralObra.vue`) para o barrel
 * (`@/views/CREObras`, `.then((m) => m.carregarListarDashboardGeralObra())`).
 * O barrel publica uma FUNÇÃO de carregamento preguiçoso, não o componente
 * reexportado estaticamente — medido: a versão estática engordava o chunk
 * principal em ~670 kB porque `Obra.ts`/`Geral.ts` importam este mesmo
 * barrel de forma ESTÁTICA (para `creObrasRotas`), ver `views/CREObras/index.ts`.
 * A exceção `no-deep-cross-domain-excecao-crefabrica-creobras` de
 * `.dependency-cruiser.cjs` saiu junto, como o próprio comentário dela
 * previa. Travado em `src/views/CREFabrica/__tests__/dependencias-externas.spec.ts`.
 */
const metaPadrao = {
  subject: ["PROJETO_FABRICA"],
  showMenu: true,
  grupo: "Projetos Fábrica",
  grupoTitle: "Projetos Fábrica",
};

const rotas = {
  obra: [
    {
      path: "/:obra/fabricacao/Dashboard",
      name: "Fabrica Dashboard Obra",
      component: () => import("@/views/CREObras").then((m) => m.carregarListarDashboardGeralObra()),
      meta: {
        breadcrumb: "Todas as Fabricações|Fabricação",
        title: "Fabrica Dashboard Obra",
        icon: "mdi-view-dashboard-outline",
        ...metaPadrao,
        action: ["admin_projetos_fabrica"],
      },
    },
    {
      path: "projetos",
      name: "Projetos de fabrica",
      component: () => import("./DashboardFabrica.vue"),
      meta: {
        breadcrumb: "Todas as Fabricações|Fabricação",
        title: "Projetos de fabrica",
        icon: "mdi-text-box-multiple-outline",
        ...metaPadrao,
      },
    },
    {
      path: "projetos/Mecanica",
      name: "Mecânica de Fábrica",
      component: () => import("./DashboardFabrica.vue"),
      meta: {
        breadcrumb: "Todas as Fabricações|Fabricação",
        title: "Mecânica",
        icon: "mdi-tools",
        query: { categoria: "Mecânica" },
        ...metaPadrao,
      },
    },
    {
      path: "projetos/Eletrica",
      name: "Elétrica de Fábrica",
      component: () => import("./DashboardFabrica.vue"),
      meta: {
        breadcrumb: "Todas as Fabricações|Fabricação",
        title: "Elétrica",
        icon: "mdi-lightning-bolt",
        query: { categoria: "Elétrica" },
        ...metaPadrao,
      },
    },
  ],
  geral: [
    {
      path: "/fabrica/Dashboard",
      name: "Fabrica Dashboard",
      component: () => import("@/views/CREObras").then((m) => m.carregarListarDashboardGeralObra()),
      meta: {
        breadcrumb: "",
        title: "Fabrica Dashboard",
        icon: "mdi-view-dashboard-outline",
        ...metaPadrao,
        action: ["admin_projetos_fabrica"],
      },
    },
    {
      path: "projetos-fabrica",
      name: "Todos projetos de fábrica",
      component: () => import("./DashboardGeralFabrica.vue"),
      meta: {
        breadcrumb: "Todas as Fabricações",
        title: "Todos projetos de fábrica",
        icon: "mdi-text-box-multiple-outline",
        ...metaPadrao,
      },
    },
    {
      path: "projetos-fabrica/Eletrica",
      name: "Elétrica geral de Fábrica",
      component: () => import("./DashboardGeralFabrica.vue"),
      meta: {
        breadcrumb: "Todas as Fabricações|Todos projetos de fábrica",
        title: "Elétrica",
        icon: "mdi-lightning-bolt",
        query: { categoria: "Elétrica" },
        ...metaPadrao,
      },
    },
    {
      path: "projetos-fabrica/Mecanica",
      name: "Mecânica geral de Fábrica",
      component: () => import("./DashboardGeralFabrica.vue"),
      meta: {
        breadcrumb: "Todas as Fabricações|Todos projetos de fábrica",
        title: "Mecânica",
        icon: "mdi-tools",
        query: { categoria: "Mecânica" },
        ...metaPadrao,
      },
    },
  ],
};

export default rotas;
